import {NotificationEvent} from './notification-event.model';

export class NotificationGroupEvent {

    // Server Properties
    ID: number;
    NotificationGroup_ID: number;
    NotificationType_ID: number;
    NotificationEvent_ID: number;
    AddedOn: Date;
    AddedBy: number;
    LastUpdatedOn: Date;
    LastUpdatedBy: number;

    // Local Properties
    NotificationEvent: NotificationEvent;

    // Constructors
    constructor(
        notificationEvent?: NotificationEvent,
        notificationGroupId?: number,
        notificationTypeId?: number
    ) {
        if (notificationEvent) {
            this.NotificationEvent_ID = notificationEvent.ID;
            this.NotificationEvent = notificationEvent;
        }
        if (notificationGroupId) {
            this.NotificationGroup_ID = notificationGroupId;
        }
        if (notificationTypeId) {
            this.NotificationType_ID = notificationTypeId;
        }
    }
}
